import axios from "axios";
import {environmentConfig} from "@/config/enviromentConfig";

export default class WorldPlayService {
  static async getUser(msisdn, productId) {
    const response = await axios.post(`${environmentConfig.worldPlayHost}/get-user`, {
      msisdn: msisdn,
      productId: productId,
    }, { timeout: 8000 })
    return response.data;
  }

}
